import Totals from "../crew/Totals";
import BigNum from "../math/BigNum";
import GameTime from "../time/GameTime";
import NumberValue from "../value/NumberValue";
import Bonus from "./Bonus";

export default class NumberValueBonus extends Bonus {
    /**
     * @param {string} id 
     * @param {string} title 
     * @param {string} description 
     * @param {string} spriteFileName 
     * @param {GameTime} gameTime
     * @param {Totals} totals
     * @param {BigNum} cost
     * @param {number} activationTurns
     * @param {NumberValue} numberValue
     * @param {number} activeValue The value to set numberValue to when activated.
     */
    constructor(id, title, description, spriteFileName, gameTime, totals, cost, activationTurns, numberValue, activeValue) {
        super(id, title, description, spriteFileName, gameTime, totals, cost, activationTurns);

        /**
         * @constant
         * @type {NumberValue}
         */
        this.numberValue = numberValue;
        /**
         * @constant
         * @type {number}
         */
        this.activeValue = activeValue;
    }

    /**
     * @override
     * @returns {boolean}
     */
    onActivation() {
        if (!super.onActivation()) {
            return false;
        }

        this.numberValue.incrementValue(this.activeValue);
        return true;
    }

    /**
     * @override
     */
    onActivationFromSave() {
        super.onActivationFromSave();
        this.numberValue.incrementValue(this.activeValue);
    }

    /**
     * @override
     */
    onDeactivation() {
        if (!super.onDeactivation()) {
            return false;
        }

        this.numberValue.decrementValue(this.activeValue);
        return true;
    }

    /**
     * Returns a number value that represents the bonus.
     * @override
     * @returns {number}
     */
    getActivationValue() {
        return this.activeValue;
    }

    /**
     * @override
     */
    reset() {
        super.reset();
        this.numberValue.reset();
    }
}